<template>
    <layout-view navTitle="Фильтры">
      <template v-slot:nav>
        <div class="px-4">
          <!-- <com-branch-autocomplete-multiple class="pt-1" :select.sync="comBranchsSelected" globalState/> -->
          <v-btn small block depressed color="silver" @click="createUpdateState.modalOpen({
              name:null,
              type: null,
              description: null,
              docxFile: null
            })">
            Создать
          </v-btn>
        </div>
      </template>
      <template v-slot:content="{height}">
        <n-table-view
          ref="table"
          name="Список шаблонов"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="headers"
        >
          <template v-slot:item="{ item }">
            <tr @click="createUpdateState.modalOpen($tools.copy(item))">
              <td class="text-no-wrap">{{item.id}}</td>
              <td class="text-no-wrap">
                {{item.name}}
              </td>
              <td class="text-no-wrap">
                {{item.type}}
              </td>
              <td>
                {{item.description}}
              </td>
            </tr>
          </template>
        </n-table-view>
        
        <dialog-editor
            :name="createUpdateState.modalData?.id !== undefined ?'Редактировать' : 'Создать шаблон'"
            submitText="Сохранить"
            :item.sync="createUpdateState.modalData"
            disableOverlayClick
            @submit="createUpdateTemplate()"
        >
          <!-- <template v-slot:afterTitle>
             <v-toolbar-title class="ml-1">{{ createUpdateState.modalData?.name }}</v-toolbar-title>
          </template> -->
          <template v-slot:actions v-if="createUpdateState.modalData?.id !== undefined">
            <v-btn icon @click="downloadTemplate(createUpdateState.modalData)">
              <v-icon class="pt-1">mdi-download</v-icon>
            </v-btn>
            <btn-icon-accept @accept="deleteTemplate(createUpdateState.modalData?.id)" icon="mdi-delete" text="Удалить?"/>
          </template>

          <v-form ref="blockCreateUpdateForm" v-if="createUpdateState.modalData!=null">
              <v-text-field label="Название" class="mb-4" v-model="createUpdateState.modalData.name" :rules="formFieldRules.required" outlined dense hide-details="auto"/>

              <v-combobox
                v-model="createUpdateState.modalData.type"
                :items="types"
                label="Тип"
                outlined
                dense
                clearable
                class="mb-4"
              />

              <v-textarea
                label="Описание"
                v-model="createUpdateState.modalData.description"
                outlined dense hide-details="auto" auto-grow rows="4"
                class="mb-4"
              />

              <div class="mb-4 caption">{{createUpdateState.modalData?.id !== undefined ? 'Заменить' : 'Выберите'}} файл документа Microsoft Word (.docx)</div>
              <v-file-input label="Файл" class="mb-4" prepend-icon="" v-model="createUpdateState.modalData.docxFile " accept=".docx" outlined dense hide-details="auto" />

          </v-form>
        </dialog-editor>


    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import {FormFieldRules} from "@/plugins/formFieldRules";
import axios from "axios";

import {
  Entity_MrDocxBlock,
} from "../../../../EntityStoreCacheService";
import NTableView from "@/componentsV2/base/NTableView.vue";
import LayoutView from "@/components/LayoutView";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";

export default {
  components: {
    NTableView, 
    DialogEditor,
    LayoutView,
    BtnIconAccept
  },
  data: () => ({
    formFieldRules: FormFieldRules,
    headers: [
      { text: 'ID', value: 'id', class:'text-no-wrap', sortable: true},
      { text: 'Название', value: 'name', sortable: true},
      { text: 'Тип', value:'type', sortable: false},
      { text: 'Описание', value:'description', sortable: false},
    ],

    loadState: new State(),
    createUpdateState: new State(),

    types: [],
  }),
  mounted() {
    this. loadBlockTypes()
  },
  methods:{
    loadBlockTypes(){
      new Entity_MrDocxBlock()
      .selects(Entity_MrDocxBlock.id)
      .selects(Entity_MrDocxBlock.type)
      .page(null) 
      .addStateCallback((v)=>{this.loadState.setRequestBuilderState(v)})
      .request((data)=>{
        this.types = [...new Set(data.items.map(i => i.type))];
      }, (e)=>{
        console.error(e.response.data.message);
      })

    },
    genRequestBuilder(page, onPage, sortFields){
      let rb  = new Entity_MrDocxBlock()

      .selects(Entity_MrDocxBlock.id)
      .selects(Entity_MrDocxBlock.name)
      .selects(Entity_MrDocxBlock.slug)
      .selects(Entity_MrDocxBlock.createdAt)
      .selects(Entity_MrDocxBlock.description)
      .selects(Entity_MrDocxBlock.filePath)
      .selects(Entity_MrDocxBlock.type)
   

      rb.page(page).onPage(onPage)
    
      sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
      })

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })

      return rb;
    },
   
    createUpdateTemplate() {
      if (!this.$refs.blockCreateUpdateForm.validate()) {
        this.$store.commit('alertWarning', 'Поля формы не заполнены');
        return;
      }


      let formData = new FormData();
      Object.keys(this.createUpdateState.modalData).forEach((key)=>{
        formData.append(key, this.createUpdateState.modalData[key]);
      });

      let endpoint = this.createUpdateState.modalData?.id !== undefined ? `/mr/blocks/${this.createUpdateState.modalData.id}'` : '/mr/blocks'

      axios.post(Api.host+endpoint,formData).then(()=>{
        this.$refs.table.load();
        this.createUpdateState.modalClose();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    deleteTemplate(id) {
      axios.delete(Api.host+'/mr/blocks/'+id).then(()=>{
        this.$refs.table.load();
        this.updateState.modalClose();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    downloadTemplate(template) {
      const id = template.id
      const name = template.name 
      axios.get(Api.host+'/mr/blocks/'+id+'/docx', {
        responseType: 'blob',
      }).then((response)=>{
        console.log(response);
        const blob = new Blob([response.data]);

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = name+'.docx';
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
  }
}
</script>